import { ExploreMapFeatureCollectionSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type ExploreMapFeatureCollectionInput = z.input<typeof ExploreMapFeatureCollectionSchema>;
export type ExploreMapFeatureCollectionOutput = z.output<typeof ExploreMapFeatureCollectionSchema>;

export function serializeExploreMapFeatureCollection(
  payload: ExploreMapFeatureCollectionInput
): ExploreMapFeatureCollectionOutput {
  return ExploreMapFeatureCollectionSchema.parse(payload);
}
